import axios from '@/libs/api.request';
import search from '@/libs/search';
import axiosRequest from 'axios';
import { getUnitList } from '@/api/modules/system-management/unit-management';

export const getPackageList = data => {
    return axios.request({
        url: 'api/systemManagement/packageManagement/getPackageList',
        data: data,
        method: 'post'
    });
};

export const savePackage = data => {
    return axios.request({
        url: 'api/systemManagement/packageManagement/savePackage',
        data: data,
        method: 'post'
    });
};

export const pageInit4PackageList = () => {
    const unitSearch = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getUnitList(unitSearch)
    ]).then(axiosRequest.spread(function (unit) {
        if (unit.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    unit: unit.data
                }
            };
        }
    }));
};
